import * as angular from 'angular';
import { HelpCenterUrlService } from './help-center-url.service';
import { ChartOfAccountsHelpAnchor } from './chart-of-accounts-help-anchor.enum';
import { JournalReversalCodeLinks } from './journal-reversal-code-links.constant';

export const HelpCenterUrlModule = angular.module('buildium.manager.help-center-url', [])
    .constant('ChartOfAccountsHelpAnchor', ChartOfAccountsHelpAnchor)
    .constant('JournalReversalCodeLinks', JournalReversalCodeLinks)
    .service('HelpCenterUrlService', HelpCenterUrlService);
